@if (position > 0) {
  <nav class="flex" aria-label="Breadcrumb">
    <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
      <li *ngFor="let title of titles;index as i; ">
        <div class="flex items-center">
          <svg *ngIf="i > 0" class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m1 9 4-4-4-4" />
          </svg>
          <span [ngClass]="{'text-primary' : i === (position-1)}"
                class="ms-1 text-sm text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white">{{ title }}</span>
        </div>
      </li>
    </ol>
  </nav>
}

